import React from "react";
import { rowColumn } from "../../../components/table/Table";
import { assignStatusExternalOptions, assignStatusExternalSecondaryOptions } from "../../utils/assignStatusExternalOptions";
import { getFilterOptions } from "../../CommonFunctions";

export enum KindergartenApplicationState {
  pending = "pending",
  submitted = "submitted",
}

export const kindergartenApplicationsListTable = (currPath: string, state: KindergartenApplicationState): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "firstName",
    type: "string",
    allowSort: true,
    sortOn: "FirstName",
  },
  {
    label: "Last Name",
    column: "lastName",
    type: "string",
    allowSort: true,
    sortOn: "LastName",
  },
  {
    label: "Kindergarten",
    column: "fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "FundedKinderName",
    body: (rowData) => {
      return <p className="m-0">{rowData.fundedKinderName === "Other" ? rowData.kindergartenNameOther : rowData.fundedKinderName}</p>;
    },
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    allowSort: true,
    disableSearch: true,
    sortOn: "StatusComputed",
    isFilter: state === KindergartenApplicationState.submitted,
    filterType: "multiselect",
    filterElements: getFilterOptions(assignStatusExternalOptions, getSecondaryStatusOptions()),
  },
  {
    label: "Actions",
    body: (rowData) => <a href={`${currPath}/${rowData.id}`}>View Details</a>,
  },
];

function getSecondaryStatusOptions() {
  return {
    ...assignStatusExternalSecondaryOptions,
    Application: assignStatusExternalSecondaryOptions.Application.filter((item) => item.label !== "Not submitted"),
  };
}
